import React from 'react';

import * as apiUtil from "../../../util/apiUtil";

import JoinHeader from "../component/JoinHeader";
import Footer from "../../../component/layout/Footer";

import loginPageCss from "../css/loginPage.module.css";
import "../css/loginPage.css"

class JoinSelectHostingContainer extends React.Component {
    constructor(props) {
        super(props);

        this.ajaxAgreeCheck = this.ajaxAgreeCheck.bind(this);
        this.goNextPage = this.goNextPage.bind(this);

        this.state = {
            jToken: props.jToken,
            tMail: props.tMail,
            tMms: props.tMms
        }
    }

    componentDidMount() {
        const { kToken } = this.props;

        /* 카카오싱크 동의항목 조회 */
        if(kToken) {
            apiUtil.asyncRequest({
                setLoading: this.setLoading,
                url: `/api/auth/kakao/agree`,
                method: apiUtil.requestMethod.POST,
                redirect_url: "/",
                data: {
                    tokenKko: kToken,
                },
                success: (result) => {
                    this.setState({
                        kToken: kToken,
                        jToken: result.tokenJoin,
                        tMms: result.termsMms,
                        tMail: result.termsMail
                    }, () => {
                        this.ajaxAgreeCheck()
                    });
                }
            });
        } else {
            this.ajaxAgreeCheck()
        }
    }

    ajaxAgreeCheck() {
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: `/api/auth/agree/check`,
            method: apiUtil.requestMethod.POST,
            redirect_url: "/",
            data: {
                tokenJoin: this.state.jToken,
            }
        });
    }

    goNextPage(hostType) {
        let paramStr = "?htype=" + hostType;

        if(this.state.kToken) paramStr += "&kToken=" + this.state.kToken;

        paramStr += "&jToken=" + encodeURIComponent(this.state.jToken);
        paramStr += "&tMail=" + this.state.tMail;
        paramStr += "&tMms=" + this.state.tMms;

        window.location.href = "/register/info" + paramStr;
    }

    render() {
        const { goNextPage } = this;

        return (
            <>
                <div className={"container-xxl"}>
                    <JoinHeader
                        joinStep={2}
                    >
                        <div className={`${loginPageCss["card"]} pt-5 card card-body text-center ${loginPageCss["hosting-list"]}`}>
                            <h5 className='fs-4'>사용 중인 호스팅 업체를 선택하세요</h5>
                            <ul className={`${loginPageCss["list-unstyled"]}`}>
                                <li>
                                    <button className='btn btn-secondary w-100 ' onClick={() => goNextPage("N")}>없음</button>
                                </li>
                                <li>
                                    <button className='btn btn-primary w-100' onClick={() => goNextPage("C")}>카페24
                                        <span className="material-symbols-rounded align-middle ms-1 fs-5">arrow_forward</span>
                                    </button>
                                </li>
                            </ul>
                            <div className={`${loginPageCss["bottom-line"]}`}></div>
                        </div>
                    </JoinHeader>
                </div>
                <Footer />
            </>
        )
    }
}

export default JoinSelectHostingContainer;
